const t={exposeLibraryMetadata:!0,showPayButton:!0};export{t as defaultProps};
//# sourceMappingURL=core.defaultProps.js.map
